import React from "react";
import { Trending } from "pages";

const TrendingRoute = () => {
  return (
    <>
      <Trending />
    </>
  );
};

export default TrendingRoute;
